import { apiClient } from '../client';
import type { Paginated, PaginationQuery } from './types';

export interface Person {
  id: number;
  accountId: number | null;
  salutation: string | null;
  firstName: string | null;
  lastName: string;
  title: string | null;
  department: string | null;
  jobTitle: string | null;
  isDecisionMaker: boolean;
  phone: string | null;
  phoneAlt: string | null;
  mobile: string | null;
  email: string | null;
  emailAlt: string | null;
  addressLine1: string | null;
  zip: string | null;
  city: string | null;
  state: string | null;
  region: string | null;
  countryId: number | null;
  source: string | null;
  birthday: string | null;
  archived: boolean;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  version: number;
  account?: { id: number; name: string } | null;
  country?: { id: number; code: string; name: string } | null;
}

export type PersonListItem = Pick<
  Person,
  'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'mobile' | 'jobTitle' | 'archived' | 'account'
>;

export interface PersonListQuery extends PaginationQuery {
  accountId?: number;
  countryId?: number;
  archived?: boolean;
}

export type PersonInput = Partial<Omit<Person, 'id' | 'createdAt' | 'updatedAt' | 'version'>> & {
  lastName: string;
};

export const personsApi = {
  async list(q: PersonListQuery): Promise<Paginated<PersonListItem>> {
    const { data } = await apiClient.get<Paginated<PersonListItem>>('/persons', { params: q });
    return data;
  },
  async findOne(id: number): Promise<Person> {
    const { data } = await apiClient.get<Person>(`/persons/${id}`);
    return data;
  },
  async create(input: PersonInput): Promise<Person> {
    const { data } = await apiClient.post<Person>('/persons', input);
    return data;
  },
  async update(id: number, input: Partial<PersonInput>): Promise<Person> {
    const { data } = await apiClient.patch<Person>(`/persons/${id}`, input);
    return data;
  },
  async remove(id: number): Promise<void> {
    await apiClient.delete(`/persons/${id}`);
  },
};
